import React from "react";

const Description = () => {
  return (
    <div className="description-container">
      <p className="description-name">Tomas Alves de Souza</p>
      <p className="description-profession">Web Developer</p>
      <p className="description-item">
        I am a passionate, self-motivated person who has a great sense of
        ownership and an incredible power to adapt to new realities. Being out
        of my comfort zone motivates me.
      </p>
      <p className="description-item">
        I have over 10 years work experience but my background is mostly in the
        chemical industry. I have been studying programming and web development
        for over a year and in 2022 I have decided to fully change my career
        path onto the Tech Industry. I have graduated as a Full Stack Developer
        through Dev Academy in October 2022 and I am now working on personal
        projects while looking for my first job as a dev.
      </p>
    </div>
  );
};

export default Description;
